import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component } from '@angular/core';
import { BasePersonselectionComponent } from './base-personselection.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-personselection-compact',
    imports: [
    NgClass,
    NgTemplateOutlet,
    TranslatePipe
],
    templateUrl: './personselection-compact.component.html',
    styleUrl: './personselection-compact.component.scss'
})
export class PersonselectionCompactComponent extends BasePersonselectionComponent {

  constructor(){
    super()
  }

}

